/*
 *
 * VerifyPOSModal
 *
 * @version 1.0.0
 * @author GitHub Copilot
 * @since 04-Sep-2025
*/

import { connect } from 'react-redux'
import VerifyPOSModal from './VerifyPOSModal'
import { doHidePopup } from 'Store/actions/popup'
import { bindActionCreators } from 'redux'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doHidePopup }, dispatch)
})

const mapStateToProps = state => ({
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(VerifyPOSModal)
